import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CorreiosAuth, CorreiosServices } from 'src/app/services/correios.services';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
    selector: 'cep-disponibilidade',
    templateUrl: './cep-disponibilidade.component.html',
    styleUrls: ['./cep-disponibilidade.component.scss'],
    standalone: false
})
export class CepDisponibilidadeComponent implements OnInit {

  formValidation:UntypedFormGroup;
  sucesso: boolean;
  message: string;
  constructor(private fb:UntypedFormBuilder, private cs:CorreiosServices, private snackService:SnackbarService ) { }

  @Input() codecompany:number;
  @Input() codecontract:number;
  @Input() servico:Object;
  @Input() correiosAuth:CorreiosAuth;

  ngOnInit(): void {
      this.formValidation = this.fb.group({
          origem: new UntypedFormControl(null,[Validators.required,Validators.minLength(8),Validators.maxLength(8)]),
          destino: new UntypedFormControl(null,[Validators.required, Validators.minLength(8),Validators.maxLength(8)])
      });

      this.formValidation.valueChanges.subscribe(data=>{
          this.message = '';
      })
  }

  pesquisar(){
      this.formValidation.markAsDirty();
      this.formValidation.updateValueAndValidity();
      
      if ( this.formValidation.invalid ){
        this.snackService.showError('Não informado campos obrigatórios ou dados inválidos.');
        return;
      }

      if ( this.codecompany == 0 ){
        this.snackService.showError('Não informado a empresa para buscar disponibilidade.');
        return;
      }

      if ( this.servico == null ){
        this.snackService.showError("Para pesquisar disponibilidade, deve-se selecionar um serviço.");
        return;
      }

      this.cs.getDisponibilidade(this.codecompany,
                                 this.codecontract, 
                                 this.formValidation.get('origem').value,
                                 this.formValidation.get('destino').value,
                                 this.servico['codigo'],
                                 this.correiosAuth ).then(data=>{

              let doc:Document = new DOMParser().parseFromString(data as string,'text/xml');
              let result = doc.evaluate("//return",doc);
              let node = result.iterateNext();
              if ( node.textContent == "0#"){
                  this.sucesso = true;
                  this.message = `Serviço de ${this.servico['descricao']} disponível para essa origem e destino.`;
              }else{
                this.sucesso = false;
                this.message = `Serviço indiponível para para essa origem e destino.`
              }
           


      }).catch(error=>{
            GlobalErrorHandler.showError(error);
      });

  }

  clear(campo:string){
      this.formValidation.get(campo).setValue(null);
  }
}
